// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M18.58 2.94425C17.799 2.1632 16.5327 2.1632 15.7516 2.94425L14.1069 4.58892L19.4102 9.89222L21.0549 8.24755C21.836 7.4665 21.836 6.20017 21.0549 5.41912L18.58 2.94425Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.9958 11.307L12.6925 6.00372L3.85818 14.8391L2.78174 21.2188L9.16148 20.1424L17.9958 11.307Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-edit-filled')
export default class EditFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-filled',
    }
  }
}
